import { useQuery } from '@tanstack/react-query';
import { authApi, type AuthConfig } from '../../lib/endpoints';
import { qk } from '../../lib/queryClient';

const FALLBACK: AuthConfig = { registrationOpen: true, discordLogin: false, vapidPublicKey: null, maxUploadBytes: 2 * 1024 ** 3, maxMessageLength: 8000 };

export function useAuthConfig(): AuthConfig {
  const q = useQuery({ queryKey: qk.authConfig, queryFn: authApi.config, staleTime: 5 * 60_000 });
  return q.data ?? FALLBACK;
}
